"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Marketing, Communication, Technologie de l’Information et de la Communication"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

                <p className={"text-normal mb-8"}>
                    Directeur : Monsieur <strong>YAO Grégoire</strong>
                    <br/>
                    <br/>
                    Il est chargé de :
                </p>

                <div className={"text-normal mb-8"}>
                    <ul className="list-disc list-inside text-lg mt-8">
                        <li className="li2">Développer le partenariat entre Côte d’Ivoire Tourisme et les compagnies aériennes;
                        </li>
                        <li className="li2">Développer le partenariat entre Côte d’Ivoire Tourisme et les autres opérateurs nationaux et internationaux du secteur
                        </li>
                        <li className="li2">Impulser le développement et la production touristique dans les Régions, d’y veiller et de coordonner les Bureaux du Tourisme à l’Etranger et les Bureaux Régionaux.
                        </li>
                    </ul>
                </div>

            </SectionPage>

        </div>
    );
}
